import { z } from 'zod'
import { timestampSchema, uuidSchema } from './common.js'

export const skillInstalledSchema = z.object({
  id: uuidSchema,
  workspace_id: uuidSchema,
  skill_name: z.string().min(1).max(120),
  version: z.string(),
  source_repo: z.string(),
  source_commit: z.string().nullable(),
  description: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()).default({}),
  enabled: z.boolean(),
  installed_by: uuidSchema.nullable(),
  installed_at: timestampSchema,
  updated_at: timestampSchema,
})
export type SkillInstalled = z.infer<typeof skillInstalledSchema>

export const skillInstallRequestSchema = z.object({
  source_repo: z.string().url(),
  skill_name: z.string().min(1).max(120).optional(),
})
export type SkillInstallRequest = z.infer<typeof skillInstallRequestSchema>

export const skillInvocationSchema = z.object({
  id: uuidSchema,
  workspace_id: uuidSchema,
  session_id: uuidSchema.nullable(),
  user_id: uuidSchema.nullable(),
  skill_name: z.string(),
  operation: z.string().nullable(),
  input_summary: z.string().nullable(),
  output_summary: z.string().nullable(),
  success: z.boolean(),
  error_message: z.string().nullable(),
  duration_ms: z.number().int().nonnegative().nullable(),
  tokens_consumed: z.number().int().nonnegative().nullable(),
  cost_eur: z.number().nonnegative().nullable(),
  created_at: timestampSchema,
})
export type SkillInvocation = z.infer<typeof skillInvocationSchema>

export const scheduledSkillStatusSchema = z.enum(['never', 'running', 'success', 'error'])
export type ScheduledSkillStatus = z.infer<typeof scheduledSkillStatusSchema>

export const scheduledSkillRunSchema = z.object({
  id: uuidSchema,
  workspace_id: uuidSchema,
  skill_name: z.string().min(1).max(120),
  description: z.string().nullable(),
  schedule_cron: z.string().min(1).max(120),
  schedule_label: z.string().min(1).max(120),
  timezone: z.string().min(1).max(80),
  enabled: z.boolean(),
  last_run_at: timestampSchema.nullable(),
  next_run_at: timestampSchema.nullable(),
  last_status: scheduledSkillStatusSchema,
  last_error_message: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()).default({}),
  created_by: uuidSchema.nullable(),
  created_at: timestampSchema,
  updated_at: timestampSchema,
})
export type ScheduledSkillRun = z.infer<typeof scheduledSkillRunSchema>

export const scheduledSkillRunUpdateSchema = z.object({
  enabled: z.boolean().optional(),
  schedule_cron: z.string().min(1).max(120).optional(),
  schedule_label: z.string().min(1).max(120).optional(),
  timezone: z.string().min(1).max(80).optional(),
})
export type ScheduledSkillRunUpdate = z.infer<typeof scheduledSkillRunUpdateSchema>
